<div class="dialog-style">
    <h1 mat-dialog-title>{{ title }}</h1>
    
    <!-- Spinner for loading state -->
    <div *ngIf="isLoading" class="loading-container">
      <div id="loadingWrapper" *ngIf="isLoading">
        <div class="loading-icon">
          <div class="loading-outer"></div>
          <div class="loading-inner"></div>
        </div>
      </div>
      <div mat-dialog-content>{{ loadingMessage }}</div>
    </div>
  
    <!-- Normal content if not loading -->
    <div *ngIf="!isLoading">
      <!-- HTML content block -->
      <div mat-dialog-content style="width:300px" *ngIf="isHtmlContent" [innerHTML]="html"></div>
      
      <!-- Plain text content block -->
      <div mat-dialog-content *ngIf="!isHtmlContent">{{ content }}</div>
    </div>
  
    <div mat-dialog-actions *ngIf="!isLoading">
      <button mat-raised-button class="btn" mat-dialog-close>{{ closeButton }}</button>
    </div>
  </div>
  